import SiteWrapper from "@/SiteWrapper";
import {
  activeDirectoryApi,
  adminFormsApi,
  appConfigApi,
  approvalWorkflowApi,
  backdatingApi,
  baselineDateApi,
  commentApi,
  conditionalAccessApi,
  ctqSnapshotApi,
  dashboardApi,
  dynamicFieldApi,
  formsApi,
  historyApi,
  issuesApi,
  keyMilestonesApi,
  projectIssueCategoriesApi,
  projectIssueStatusesApi,
  milestoneTemplateApi,
  notificationGroupApi,
  permissionsApi,
  projectApi,
  projectApprovalApi,
  projectImageApi,
  projectMilestoneDocumentApi,
  projectRoleApi,
  projectTemplateApi,
  projectRisksApi,
  projectRiskCategoriesApi,
  projectImpactAreasApi,
  projectRiskStatusesApi,
  storageApi,
  userApi,
  userReplacementApi,
} from "@/services";
import { MsalProvider } from "@azure/msal-react";
import { configureStore } from "@reduxjs/toolkit";
import { object } from "prop-types";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import "./App.css";
import Pages from "./Pages";
import { ProjectIntakeSubmitProvider } from "./components";
import IntlProvider from "./locales/IntlProvider";
import {
  AuthWrapper,
  FormPropertyProvider,
  FormPropertyValueLookupProvider,
  NavigationProvider,
  UserProvider,
} from "./providers";
import { rootReducer } from "./store";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      activeDirectoryApi.middleware,
      adminFormsApi.middleware,
      approvalWorkflowApi.middleware,
      backdatingApi.middleware,
      baselineDateApi.middleware,
      commentApi.middleware,
      conditionalAccessApi.middleware,
      ctqSnapshotApi.middleware,
      dashboardApi.middleware,
      notificationGroupApi.middleware,
      dynamicFieldApi.middleware,
      formsApi.middleware,
      historyApi.middleware,
      issuesApi.middleware,
      keyMilestonesApi.middleware,
      projectIssueCategoriesApi.middleware,
      projectIssueStatusesApi.middleware,
      projectRisksApi.middleware,
      projectRiskCategoriesApi.middleware,
      projectImpactAreasApi.middleware,
      projectRiskStatusesApi.middleware,
      milestoneTemplateApi.middleware,
      permissionsApi.middleware,
      projectApi.middleware,
      projectApprovalApi.middleware,
      projectImageApi.middleware,
      projectMilestoneDocumentApi.middleware,
      projectRoleApi.middleware,
      projectTemplateApi.middleware,
      storageApi.middleware,
      userApi.middleware,
      appConfigApi.middleware,
      userReplacementApi.middleware
    ),
});

const App = ({ pca }) => (
  <MsalProvider instance={pca}>
    <Provider store={store}>
      <IntlProvider>
        <NavigationProvider>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <AuthWrapper>
              <UserProvider>
                <FormPropertyValueLookupProvider>
                  <FormPropertyProvider>
                    <ProjectIntakeSubmitProvider>
                      <SiteWrapper>
                        <Pages />
                      </SiteWrapper>
                    </ProjectIntakeSubmitProvider>
                  </FormPropertyProvider>
                </FormPropertyValueLookupProvider>
              </UserProvider>
            </AuthWrapper>
          </QueryParamProvider>
        </NavigationProvider>
      </IntlProvider>
    </Provider>
  </MsalProvider>
);

App.propTypes = {
  pca: object.isRequired,
};

export default App;
